var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tag tag-item-edit"},[_c('dash-icon',{staticClass:"icon",attrs:{"icon":"source-manual"}}),_c('span',{staticClass:"overrides-value"},[_vm._v(_vm._s(_vm.value))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }